import { createContext } from 'react'

// Contexts live apart from their providers so provider files export only
// components (react-refresh/only-export-components).

export const ApiClientContext = createContext(null)
export const RealtimeContext = createContext(null)
export const SessionContext = createContext(null)

// Query key of the /api/v1/me session query — invalidate this to force a
// session refresh from anywhere.
export const ME_QUERY_KEY = ['/api/v1/me', null]
